import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const WillCallIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect x="0" y="0" width="24" height="24" />
        <path
          fill={color}
          {...color !== "currentColor" && { fillOpacity: ".65" }}
          fillRule="nonzero"
          d="M3.87323358,7.3883736 C2.74788573,6.68054288 2,5.42761048 2,4 C2,1.790861 3.790861,0 6,0 C8.209139,0 10,1.790861 10,4 C10,5.42720203 9.25254216,6.67982593 8.12773223,7.38776592 C10.3912064,8.24549131 12,10.43197 12,12.9945942 L12,14 L14,14 L14,10.5 C14,8.70204328 15.0572708,7.14911997 16.5826721,6.42858946 C15.6294871,5.80327695 15,4.72515077 15,3.5 C15,1.56700338 16.5670034,0 18.5,0 C20.4329966,0 22,1.56700338 22,3.5 C22,4.7251273 21.370537,5.80323565 20.4173827,6.42855352 C21.9432609,7.14932166 23,8.70293098 23,10.5 L23,14 L23.5,14 C23.7761424,14 24,14.2238576 24,14.5 C24,14.7761424 23.7761424,15 23.5,15 L12,15 L12,16.5 C12,16.7761424 11.7761424,17 11.5,17 L8.9655596,17 L8.49872935,23.5356235 C8.48003987,23.7972762 8.26231933,24 8,24 L4,24 C3.73768067,24 3.51996013,23.7972762 3.50127065,23.5356235 L3.0344404,17 L0.5,17 C0.223857625,17 0,16.7761424 0,16.5 L0,12.9945942 C0,10.4342324 1.6110278,8.24689864 3.87323358,7.3883736 Z M22,14 L22,10.5 C22,8.56985922 20.4313584,7 18.5,7 C16.5698592,7 15,8.56864156 15,10.5 L15,14 L22,14 Z M18.5,6 C19.8807119,6 21,4.88071187 21,3.5 C21,2.11928813 19.8807119,1 18.5,1 C17.1192881,1 16,2.11928813 16,3.5 C16,4.88071187 17.1192881,6 18.5,6 Z M8.00127065,16.4643765 C8.01996013,16.2027238 8.23768067,16 8.5,16 L11,16 L11,12.9945942 C11,10.2358023 8.76179428,8 6,8 C3.24242568,8 1,10.238484 1,12.9945942 L1,16 L3.5,16 C3.76231933,16 3.98003987,16.2027238 3.99872935,16.4643765 L4.4655596,23 L7.5344404,23 L8.00127065,16.4643765 Z M6,7 C7.65685425,7 9,5.65685425 9,4 C9,2.34314575 7.65685425,1 6,1 C4.34314575,1 3,2.34314575 3,4 C3,5.65685425 4.34314575,7 6,7 Z"
        />
      </g>
    </g>
  </svg>
);

WillCallIcon.displayName = "WillCallIcon";

WillCallIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

WillCallIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default WillCallIcon;
